import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { SegmentedControl } from '@kerfjs/ui/segmented-control';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import type { SafeHtml } from 'kerfjs';
import { BarChart3, LayoutList, MessageSquare, Settings } from 'lucide';

import { primaryView } from '../../../components/ui-helpers.js';
import { currentCapabilities, type PrimaryView } from '../../../lib/context.js';

const VIEW_CHOICES: Record<PrimaryView, { label: string; icon: typeof LayoutList }> = {
  demands: { label: 'Demands', icon: LayoutList },
  chat: { label: 'Chat', icon: MessageSquare },
  stats: { label: 'Stats', icon: BarChart3 },
  settings: { label: 'Settings', icon: Settings },
};

/** Primary-view switcher shared by the sidebar and collapsed main toolbar. Its
 *  choices are the role's primary views; Settings is one for every role (HS2-CJM2YK). */
export function ViewSegmentedControl({ view: v }: { view: string }): SafeHtml {
  const views = currentCapabilities().primaryViews;
  return (
    <ToolbarControlGroup label="View" appearance="contained" relocateOnCollapse>
      <SegmentedControl<string>
        id="primary-view"
        label="View"
        value={primaryView(v)}
        action="seg-view"
        appearance="toolbar"
        shape="pill"
        size="small"
        choices={views.map((value) => {
          const { label, icon } = VIEW_CHOICES[value];
          return { value, label, title: label, content: <LucideIcon icon={icon} name={label} /> };
        })}
      />
    </ToolbarControlGroup>
  );
}
